import { render } from "./TrxAmbassador.vue?vue&type=template&id=58e5952f&scoped=true"
import script from "./TrxAmbassador.vue?vue&type=script&lang=js"
export * from "./TrxAmbassador.vue?vue&type=script&lang=js"

import "./TrxAmbassador.vue?vue&type=style&index=0&id=58e5952f&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58e5952f"]])

export default __exports__